
import React, { useState } from "react";
import { 
  exportApprovalFlowBundleByRequestId, 
  TARGET_REQUEST_IDS, 
  FlowBundle 
} from "../../services/debugApprovalFlowsExporter";
import { useToast } from "../Toast";

export function DebugApprovalFlowsExporterPanel() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<FlowBundle[]>([]);

  const handleRunExport = async () => {
    setLoading(true);
    setResults([]);
    try {
      const bundles: FlowBundle[] = [];
      for (const id of TARGET_REQUEST_IDS) {
        const res = await exportApprovalFlowBundleByRequestId(id);
        bundles.push(res);
      }
      setResults(bundles);
      showToast(`Exported ${bundles.length} items`);
    } catch (e: any) {
      showToast("Error: " + e.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const copyJson = (data: any) => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    showToast("JSON Copied");
  };

  return (
    <div style={{display:'flex', flexDirection:'column', gap: 20}}>
      <div className="section" style={{borderLeft: '4px solid #a855f7'}}>
        <h3 className="h1" style={{color:'#d8b4fe'}}>簽核資料匯出工具 (只讀)</h3>
        <p className="p">
          針對指定的 5 筆 Request ID，強制掃描 /approvalFlows 集合及其子集合，並匯出完整 JSON。<br/>
          此工具不執行任何寫入操作，僅供救援與除錯使用。
        </p>
        
        <div style={{marginBottom:12}}>
            <div className="label">Target IDs:</div>
            <div style={{fontFamily:'monospace', fontSize:12, color:'#aaa', background:'rgba(0,0,0,0.3)', padding:8, borderRadius:4}}>
                {TARGET_REQUEST_IDS.join(", ")}
            </div>
        </div>

        <div style={{display:'flex', gap: 10}}>
           <button className="btn" style={{width:'auto'}} onClick={handleRunExport} disabled={loading}>
             {loading ? "掃描中..." : "一鍵掃描並匯出"}
           </button>
           {results.length > 0 && (
             <button className="btn" style={{width:'auto', background:'#333'}} onClick={() => copyJson(results)}>
               複製全部結果 JSON
             </button>
           )}
        </div>
      </div>

      {results.length > 0 && (
        <div style={{display:'flex', flexDirection:'column', gap: 16}}>
           {results.map(r => (
             <div key={r.requestId} className="card" style={{border: r.found ? '1px solid var(--ok)' : '1px solid var(--danger)'}}>
                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8}}>
                    <div style={{fontWeight:'bold', fontFamily:'monospace', color:'#fff'}}>{r.requestId}</div>
                    <div className="badge" style={{color: r.found?'var(--ok)':'var(--danger)'}}>
                        {r.found ? `Found (${r.strategy})` : 'Not Found'}
                    </div>
                </div>
                
                {r.found && (
                    <>
                        <div style={{fontSize:12, color:'#aaa', marginBottom:4}}>Flow ID: {r.flowId}</div>
                        <div style={{fontSize:12, color:'#aaa', marginBottom:12}}>Subcollections: {Object.keys(r.subcollections||{}).join(", ") || "None"}</div>
                        
                        <div style={{display:'flex', gap:10}}>
                             <button className="smallbtn" onClick={() => copyJson(r)}>複製此筆 Bundle</button>
                             <button className="smallbtn" onClick={() => copyJson(r.data)}>複製 Flow Data Only</button>
                        </div>

                        <details style={{marginTop:12}}>
                            <summary style={{cursor:'pointer', color:'#a5b4fc', fontSize:12}}>查看 Raw JSON</summary>
                            <pre style={{maxHeight: 200, overflow:'auto', fontSize:11, background:'#111', padding:8, marginTop:4, color:'#ccc'}}>
                                {JSON.stringify(r, null, 2)}
                            </pre>
                        </details>
                    </>
                )}
                {r.error && <div className="err">{r.error}</div>}
             </div>
           ))}
        </div>
      )}
    </div>
  );
}

